import useFetch from './fetch';

export default function useGetTags() {
  const fetch = useFetch();
  return () => { return fetch(`/api/tags`).then(x => x.json()) };
};
